import * as CONSTANTS from "../../../../Constants/index";
import { filterPayloadType } from "../../../../Types/filterPayloadType";
import { storeFilter } from "../../../../Redux/Actions/filterActions";
import { storeSaveResponse } from "../../../../Redux/Actions/popupActions";
import store from "../../../../Store/store";

export const dispatchEditSaveResponse = (
  operationType: string | undefined,
  response: { status: "success" | "error"; message?: string }
) => {
  if (operationType === CONSTANTS.OPERATION_TYPES.EDIT_FAMILY_GROUP) {
    store.dispatch(storeSaveResponse(response));
  }
};

export const addFamilyGroupDescription = (
  item: any,
  index: number,
  arr: any[]
) => {
  item.FamilyGroupWithDescription = `${item.FamilyGroup}`;
  arr[index] = item;
};

export const handleTotalCountChange = (
  count: number,
  filterState: any,
  dispatch: (action: any) => void
) => {
  if (!count || count <= 0) return;
  const { searchPageReset, data, selectedMenu, parentName, createPopupName, deletePopupName } =
    filterState;
  const isReset =
    searchPageReset === "searchQueryPageReset" ||
    searchPageReset === "fullPageReset";
  dispatch({
    type: isReset
      ? CONSTANTS.SEARCH_PAGE_RESET
      : CONSTANTS.TOTAL_COUNT_CHANGED,
    payload: count,
  });
  if (isReset) {
    const filterPayload: filterPayloadType = {
      data: searchPageReset === "fullPageReset" ? "" : data,
      isDirectQuery: true,
      codeScreen: "FamilyGroupDataTable 218",
      selectedMenu,
      parentName,
      createPopupName,
      deletePopupName,
      searchPageReset: "",
      description: undefined,
      nestedSearchId: undefined,
      previousParentName: undefined,
      previousQueryData: undefined,
      searchId: undefined,
    };
    store.dispatch(storeFilter(filterPayload));
  }
};
